import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { isTV } from "../../../utils/platform";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "relative",
  },
  input: {
    fontFamily: "Poppins",
    borderColor: theme.colors.Border1,
    boxSizing: "border-box",
    background: "transparent",
    outline: "none",
    color: theme.colors.TextDefault,
    width: "100%",
    "&:focus": {
      borderColor: theme.colors.Border4,
    },
    padding: theme.spacing.space12,
    minHeight: 48,
    fontSize: 16,
    lineHeight: "24px",
    "&.outlined": {
      border: `1px solid ${theme.colors.Border1}`,
      borderRadius: theme.radius.small,
      background: theme.colors.Background2,
    },
    "&.standard": {
      borderWidth: 0,
      borderRadius: 0,
      borderBottomWidth: 1,
    },
  },
  fullWidth: {
    width: "100%",
  },
  hasStartIcon: {
    paddingInlineStart: theme.spacing.space40,
  },
  hasEndIcon: {
    paddingInlineEnd: theme.spacing.space40,
  },
  startAdornment: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    marginInlineEnd: theme.spacing.space8,
    insetInlineStart: theme.spacing.space12,
  },
  content: {
    position: "relative",
    cursor: "text",
    display: "flex",
    alignItems: "center",
    fontSize: 15,
  },
  fitContent: {
    width: "fit-content",
  },
  description: {
    padding: theme.spacing.space4,
  },
  descriptionError: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
  },
  descriptionErrorIcon: {
    color: theme.colors.NotificationError,
    flexShrink: 0,
  },
  closeIcon: {
    position: "absolute",
    cursor: "pointer",
    color: theme.colors.TextSilver,
    insetInlineEnd: theme.spacing.space12,
  },
  errorBorder: {
    "&, &:focus, &.outlined": {
      borderColor: theme.colors.NotificationError,
    },
  },
  textDisable: {
    color: theme.colors.TextSilver,
  },
  endAdornment: {
    position: "absolute",
    cursor: "pointer",
  },
  label: {
    paddingBottom: theme.spacing.space4,
  },
  selected: {
    "& > div > input": {
      outline: `1px solid ${theme.colors.Border4}`,
      outlineOffset: 2,
      borderColor: "transparent !important",
    },
    "& > div > $errorBorder": {
      outlineColor: theme.colors.NotificationError,
    },
  },
  tvKeyboardOpen: {
    "& > div > input": {
      outline: `1px solid ${theme.colors.Border4}`,
      outlineOffset: 2,
      borderColor: "transparent !important",
    },
    "& > div > $errorBorder": {
      outlineColor: theme.colors.NotificationError,
    },
  },
  centerInput: {
    textAlign: "center",
  },
  upperCase: {
    textTransform: "uppercase",
  },
  infoBar: {
    top: 100,
    right: 80,
    position: "fixed",
    minWidth: 500,
    zIndex: theme.zIndex.appBar,
    display: "flex",
    flexDirection: "row",
    padding: `${theme.spacing.space20}px ${theme.spacing.space16}px`,
    gap: theme.spacing.space32,
    alignItems: "center",
    borderRadius: theme.radius.small,
    border: "1px solid #FFF",
    borderColor: "rgba(255, 255, 255, 0.5)",
    borderBottom: "none",
    borderRight: "none",
    background: isTV
      ? "rgba(4, 4, 4, 0.78)"
      : "linear-gradient(0deg, rgba(4, 4, 4, 0.50) 0%, rgba(4, 4, 4, 0.50) 100%), linear-gradient(123deg, rgba(79, 79, 79, 0.10) 1.74%, rgba(79, 79, 79, 0.10) 1.75%, rgba(255, 255, 255, 0.10) 33.05%, rgba(79, 79, 79, 0.10) 97.16%)",
    backdropFilter: "blur(40px)",
    boxSizing: "border-box",
  },
  infoBarContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
  },
  cursorOverlay: {
    position: "absolute",
    insetBlock: 0,
    insetInline: 0,
    paddingBlock: theme.spacing.space12,
    paddingInlineStart: theme.spacing.space12,
    paddingInlineEnd: theme.spacing.space12,
    border: "1px solid transparent",
    display: "flex",
    alignItems: "center",
    pointerEvents: "none",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  cursorOverlayHasStartIcon: {
    paddingInlineStart: theme.spacing.space40,
  },
  cursorOverlayHasEndIcon: {
    paddingInlineEnd: theme.spacing.space40,
  },
  cursorOverlayCenter: {
    justifyContent: "center",
  },
  cursorText: {
    whiteSpace: "pre",
    color: theme.colors.TextDefault,
    padding: 0,
    margin: 0,
  },
  inputTextHidden: {
    color: "transparent !important",
    caretColor: "transparent",
    "&::placeholder": {
      color: "transparent",
    },
  },
  cursorCaret: {
    width: 2,
    height: 22,
    marginInlineStart: -1,
    marginInlineEnd: -1,
    background: theme.colors.TextDefault,
    borderRadius: 1,
    boxShadow: `0 0 4px ${theme.colors.TextDefault}`,
    animation: "$caretBlink 1.1s ease-in-out infinite",
    flexShrink: 0,
  },
  "@keyframes caretBlink": {
    "0%, 40%": { opacity: 1 },
    "55%, 95%": { opacity: 0 },
    "100%": { opacity: 1 },
  },
}));
